<template>
    <div class="home-container">
        <div class="home-banner">
            <img
                @click="goLink"
                v-if="homeInfo"
                class="banner"
                :src="homeInfo.image"
                alt=""
            />
            <img
                class="bg"
                src="https://oss.cloud.custouch.com/res/215082/bg@3x_(1).png"
                alt=""
            />
        </div>
        <div :class="['menu-box', , staffInfo ? 'staff-menu-box' : '']">
            <div
                v-for="item in menuList"
                :key="item.title"
                @click="goRoute(item)"
                class="item"
            >
                <img :src="staffInfo ? item.staffIcon : item.icon" alt="" />
                <div class="title">{{ item.title }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import anime from 'animejs'
import { sleep } from '@/utils/common'
import { concatURI, getDataModule, getLoginStaffInfo } from '@custouch/proxy-use'
const { CMS } = window.env
export default {
    name: 'home',
    data() {
        return {
            membercenterLink: window.env.VUE_APP_MEMBERCENTER_LINK,
            ssoLink: concatURI(window.env.SsoLink, {
                c_default_redirect:
                    window.location.href.split('#/')[0] +
                    this.$router.resolve({ name: 'sampleList' }).href
            }),
            isExpansion: false,
            showLogo: true,
            staffInfo: null,
            homeInfo: {},
        }
    },
    computed: {
        menuList() {
            return [
                {
                    title: '应用领域',
                    name: 'applicationField',
                    icon: 'https://oss.cloud.custouch.com/res/214571/icon-应用领域@3x.png',
                    staffIcon: 'https://oss.cloud.custouch.com/res/214694/icon-应用领域@3x.png'
                },
                {
                    title: '技术文章',
                    name: 'articleList',
                    icon: 'https://oss.cloud.custouch.com/res/214565/icon-技术文章@3x.png',
                    staffIcon: 'https://oss.cloud.custouch.com/res/214695/icon-技术文章@3x.png'
                },
                {
                    title: '资料下载',
                    name: 'document',
                    icon: 'https://oss.cloud.custouch.com/res/214566/icon-资料下载@3x.png',
                    staffIcon: 'https://oss.cloud.custouch.com/res/214696/icon-资料下载@3x.png'
                },
                {
                    title: '助剂指南',
                    name: 'guide',
                    icon: 'https://oss.cloud.custouch.com/res/214569/icon-助剂指南@3x.png',
                    staffIcon: 'https://oss.cloud.custouch.com/res/214698/icon-助剂指南@3x.png'
                },
                {
                    title: '可持续发展',
                    name: 'sustainability',
                    icon: 'https://oss.cloud.custouch.com/res/214567/icon-可持续发展@3x.png',
                    staffIcon: 'https://oss.cloud.custouch.com/res/214699/icon-可持续发展@3x.png'
                },
                {
                    title: '分销渠道',
                    name: 'ChannelDistribution',
                    icon: 'https://oss.cloud.custouch.com/res/214568/icon-分销渠道@3x.png',
                    staffIcon: 'https://oss.cloud.custouch.com/res/214702/icon-分销渠道@3x.png',
                    link: 'https://byk.cloud.pageseagle.com/779212218108948480/912214248799600640/default'
                },
                ...(this.staffInfo
                    ? [
                          {
                              title: '系统设置',
                              icon: 'https://oss.cloud.custouch.com/res/214680/icon-系统设置@3x.png',
                              staffIcon: 'https://oss.cloud.custouch.com/res/214703/icon-系统设置@3x.png',
                              ssoLink: this.ssoLink
                          }
                      ]
                    : [])
            ]
        }
    },
    methods: {
        async jumpOut(name, link) {
            this.$root.$emit('actionview', {
                info: { title: name },
                actionType: 'pageview'
            })
            await sleep(50)
            window.location.href = link
        },
        logoExpansion() {
            if (this.isExpansion) {
                window.location.href =
                    'https://www.byk.com/zh/company-news/150-years?utm_source=minisite'
                this.isExpansion = false
                return
            }
            this.isExpansion = true
        },
        goRoute(item) {
            if (item.name) {
                this.$router.push({ name: item.name })
            } else if (item.link) {
                this.jumpOut(item.title, item.link)
            } else if (item.ssoLink){
                window.location.href = item.ssoLink
            }
        },
        async goLink(){
            if (this.homeInfo.description) {
                this.$root.$emit('actionview', {
                    info: {
                        remark: `点击跳转至站外链接-${this.homeInfo.name}`,
                        to: this.homeInfo.description
                    },
                    actionType: 'clickview'
                })
                await sleep(150)
                window.location.href = this.homeInfo.description
            }
        }
    },
    async created() {
        try {
            getLoginStaffInfo().then(res=>{
                this.staffInfo = res
            })
            this.homeInfo = await getDataModule({dataModuleId: CMS.module.Home})
        } catch (error) {
            return
        }
    },
    mounted() {
        this.$root.$on('resourceLoaded', () => {
            this.isShow = true
            anime({
                targets: ['.menu-box .item'],
                opacity: [0, 1],
                scale: [0, 1],
                duration: 750,
                easing: 'spring(1, 80, 10, 0)',
                delay: anime.stagger(100, { start: 500 })
            })
        })
        // // 自2024-01-01 00:00:00起不展示150周年的icon
        // const targetDate = new Date('2024-01-01 00:00:00')
        // const currentDate = new Date()
        // this.showLogo = currentDate < targetDate
    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/style/mixin.less';
.home-container {
    .home-banner {
        position: relative;
        width: 100%;
        // height: 22rem;
        height: 52vh;
        .banner {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .bg {
            width: 100%;
            position: absolute;
            bottom: -1px;
            left: 0;
        }
    }
    .menu-box {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        padding: 0 2.1rem 5%;
        gap: 1.2rem 2.45rem;
        position: relative;
        // margin-top: -2.45rem;
        margin-top: -7vh;
        font-size: @font-size-md;
        line-height: @line-height-md;
        color: #333;
        .item{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        img {
            height: 3.5rem;
            object-fit: contain;
        }
        .title{
            white-space: nowrap;
        }
        &.staff-menu-box{
            grid-template-columns: repeat(4, minmax(0, 1fr));
            gap: @padding-lg  @padding-base*5;
            // margin-top: -2.05rem;
            margin-top: -6vh;
            padding: 0 0.7rem 5%;
            img{
                height: 3.8rem;
            }
            .title{
                margin-top: -@padding-xs;
            }
        }
    }
}
</style>
